export default "__VITE_ASSET__Bv2MSu3___"